if (!customElements.get('bth-hero-effects')) {
  customElements.define('bth-hero-effects', class extends HTMLElement {
    connectedCallback() {
      this.content = this.closest('.bth-magic-content');
      if (!this.content) return;
      this.visible = false;
      this.update = () => this.content.classList.toggle('bth-magic-visible', this.visible && !document.hidden);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      });
      this.observer.observe(this.content);
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.update);
      this.content?.classList.remove('bth-magic-visible');
    }
  });
}
